import React, { Component } from 'react';
import api from '../../../lib/api';

import {
  CreateChargebeeCustomerContainer,
  Title,
  FormSection,
  InputSection,
  DetailsOfInput,
  InputTitle,
  InputFieldWithSubmit,
  Input,
  CreateChargebeeCustomerButton,
  ResultSection,
  ErrorSection
} from './styles';

class CreateChargebeeCustomer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      companyId: '',
      operationInProgress: false,
      errorMessage: '',
      resultMessage: ''
    };
  }

  onCompanyIdChange = event => {
    event.preventDefault();

    this.setState({
      companyId: event.target.value.trim(),
      errorMessage: '',
      resultMessage: ''
    });
  };

  createChargebeeCustomer = async () => {
    const { companyId } = this.state;

    if (!companyId) {
      this.setState({
        errorMessage: 'Missing company ID',
        resultMessage: ''
      });

      return;
    }

    this.setState({
      operationInProgress: true,
      errorMessage: '',
      resultMessage: ''
    });

    try {
      await api.createChargebeeCustomer(companyId);

      this.setState({
        operationInProgress: false,
        resultMessage: 'Chargebee customer created'
      });
    } catch (error) {
      this.setState({
        operationInProgress: false,
        errorMessage:
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message) ||
          'Failed to create customer'
      });
    }
  };

  onCompanyIdKeyDown = event => {
    if (event.key === 'Enter') {
      this.createChargebeeCustomer();
    }
  };

  render() {
    const {
      companyId,
      operationInProgress,
      resultMessage,
      errorMessage
    } = this.state;

    return (
      <CreateChargebeeCustomerContainer>
        <FormSection>
          <Title>Create chargebee customer</Title>
          <InputSection>
            <DetailsOfInput>
              <InputTitle>Company ID</InputTitle>
            </DetailsOfInput>
            <InputFieldWithSubmit>
              <Input
                value={companyId}
                onChange={this.onCompanyIdChange}
                onKeyDown={this.onCompanyIdKeyDown}
              />
              <CreateChargebeeCustomerButton
                disabled={operationInProgress}
                onClick={() => this.createChargebeeCustomer()}
              >
                Create customer
              </CreateChargebeeCustomerButton>
              {resultMessage ? (
                <ResultSection>{resultMessage}</ResultSection>
              ) : null}
              {errorMessage ? (
                <ErrorSection>{errorMessage}</ErrorSection>
              ) : null}
            </InputFieldWithSubmit>
          </InputSection>
        </FormSection>
      </CreateChargebeeCustomerContainer>
    );
  }
}

export default CreateChargebeeCustomer;



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/CreateChargebeeCustomer/index.js